import styles from "./MetricsOnboarding.module.css";

const INSTALL_SNIPPET = "pip install roboto";

const PUBLISH_SNIPPET = `from roboto import Session
from roboto.domain.metrics import Metric, MetricEntry

session = Session.create(name="my-run", device_ids=["my-device"])

# Definitions are created automatically on first publish.
Metric.publish(
    session_id=session.session_id,
    metrics=[
        MetricEntry(name="cpu.usage", value=42.0),
        MetricEntry(name="battery.level", value=88.0),
    ],
)`;

/**
 * Onboarding card shown when an org has no metric definitions yet. Walks the
 * user through installing the SDK and publishing a first metric (which
 * auto-creates the definition).
 */
export function MetricsOnboarding() {
  return (
    <div className={styles.card}>
      <div className={styles.title}>No metrics yet</div>
      <div className={styles.subtitle}>
        Publish metrics from the Roboto SDK to populate this dashboard.
        Definitions are created automatically the first time you publish a
        metric.
      </div>

      <div className={styles.step}>
        <div className={styles.stepLabel}>1. Install the Roboto SDK</div>
        <pre className={styles.code}>{INSTALL_SNIPPET}</pre>
      </div>

      <div className={styles.step}>
        <div className={styles.stepLabel}>2. Publish your first metric</div>
        <pre className={styles.code}>{PUBLISH_SNIPPET}</pre>
      </div>
    </div>
  );
}
